// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT
import { AlertService } from './../../../core/services/alert.service';
import { RolesService } from './../../../core/services/roles.service';
import { Component, Input, OnInit } from '@angular/core';
import { Policy } from '@app/core';
import { Store } from '@ngrx/store';
import { State } from '@app/access-management/state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GeneralDeleteModalComponent } from '@app/access-management/shared/delete-modal/delete-modal.component';
import { RoleDetailsFacadeService } from '@app/access-management/state/role-details.facade';

@Component({
  selector: 'app-role-policies-table',
  templateUrl: './role-policies-table.component.html',
  styleUrls: ['./role-policies-table.component.scss']
})
export class RolePoliciesTableComponent implements OnInit {
  readonly columns = [
    {
      name: 'Policy Name',
      prop: 'name',
      flexGrow: 2
    },
    { name: 'Usage',
      prop: 'usage',
      flexGrow: 2
    },
    { name: 'Type',
      prop: 'type',
      flexGrow: 2
    },
    { name: 'Description',
      prop: 'description',
      flexGrow: 3
    }
  ];

  @Input() policies: Policy[] | undefined = undefined;
  @Input() roleId: any;
  constructor(
    private modalService: NgbModal,
    private roleDetailsFacadeService: RoleDetailsFacadeService,
    private store: Store<State>,
    private alertService: AlertService,
    private rolesService: RolesService) {}

  ngOnInit() {}

  onRemoveRow(row: Policy) {

    const ModalFixture = this.modalService.open(GeneralDeleteModalComponent, { centered: true, windowClass: 'no-border' });
        const modal: GeneralDeleteModalComponent = ModalFixture.componentInstance;

        modal.observable = this.rolesService.removeRolePolicy(this.roleId, row.id);

        modal.onSuccessRemove = () => {
            this.roleDetailsFacadeService.removeRolePolicySuccess(this.roleId);
            modal.close();
        };

        modal.onFailRemove = () => {
          this.roleDetailsFacadeService.removeRolePolicyError();
        };
  }

  trackColumns(idx: number) {
    return idx;
  }
}



// WEBPACK FOOTER //
// ./src/app/access-management/roles/role-policies-table/role-policies-table.component.ts